const env = {
  BASE_URL: {
    BASE_API_URL: process.env.REACT_APP_BASE_API_URL || "",
    APP_URL: process.env.REACT_APP_URL || "",
    Y3_HTTP_URL: process.env.REACT_APP_WEBSOCKET_URL || "",
    CHATBOT_URL: process.env.REACT_APP_CHATBOT_URL || "",
    COLLAB_URL: process.env.REACT_APP_COLLAB_URL || "",
    CHATBOT_BACKEND_URL: process.env.REACT_APP_CHATBOT_BACKEND_URL || "",
  },

  DEFAULT_DRUTAS_LOGO: `${process.env.REACT_APP_BASE_API_URL || ""}${process.env.REACT_APP_DEFAULT_DRUTAS_LOGO || ""}`,

  ENABLE_FIREBASE_NOTIFICATIONS: process.env.REACT_APP_ENABLE_FIREBASE_NOTIFICATIONS === "true",

  GA_MEASUREMENT_ID: process.env.REACT_APP_GA_MEASUREMENT_ID || "",
};

const common = {
  PLAYSTORE_LINK: process.env.REACT_APP_PLAYSTORE_LINK || "",
  APPSTORE_LINK: process.env.REACT_APP_APPSTORE_LINK || "",
  PAXCOM_WEBSITE_LINK: process.env.REACT_APP_PAXCOM_WEBSITE_LINK || "",

  APP_WILDCARD: "tms",
  APP_WILDCARD_REGEX: /^(.*).drutas.com(.*)$/,
  APP_BASE_DOMAIN: ".drutas.com",

  EXCLUDED_TENANT_ENVIRONMENTS: ["devqa", "uat"],
};

export default {
  ...common,
  ...env,
};
